// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import Chart from "chart.js/auto"

// Make Chart.js available globally for demo purposes
window.Chart = Chart
